// Strings of the secrets page, registered as their own bundle under `secrets` (the page owns them, like usage).
import i18n from "i18next";

export const en = {
	title: "Secrets",
	projects: "Projects",
	project: "Project",
	profileLabel: "Profile",
	revLabel: "Revision",
	changedLabel: "Changed",
	readsLabel: "Reads",
	lastReadLabel: "Last read",
	gone: "This secret is gone.",
	loading: "Loading secrets\u2026",
	retry: "Retry",
	none: "No secrets in this project yet.",
	noProjects: "No projects.",
	rev: "rev {{n}}",
	changed: "changed {{date}}",
	reads: "read {{n}}\u00d7",
	lastRead: "last {{date}} by {{name}}",
	never: "never read",
	stale: "not sealed to every recipient yet: hq secrets reseal",
	change: "Change",
	remove: "Remove",
	confirmRemove: "Remove?",
	add: "Add",
	changing: "Change {{ref}}",
	cancel: "Cancel",
	name: "NAME",
	profile: "profile (default)",
	value: "Value \u2014 encrypted here, never shown",
	save: "Encrypt & save",
	saving: "Encrypting\u2026",
	saved: "Saved {{ref}} (rev {{rev}}).",
	removed: "Removed {{ref}}.",
	badKey: "Name: letters, digits, _ (an environment variable name).",
	badProfile: "Profile: lowercase letters, digits, - or _.",
	encryptNote: "Encrypted in this browser to {{n}} recipients with their public keys. Nobody can read a value here, not even you.",
	recipients: "Recipients",
	unknownOwner: "?",
	readOnly: "You may see which secrets exist, not change them.",
	thisDevice: "This device",
	setUp: "Read secrets on this device",
	settingUp: "Setting up\u2026",
	setUpNote: "Makes a key for this device, locked by a passkey (Face ID). Values become readable here once a device that can already read them re-seals them.",
	passphrase: "Passphrase",
	newPassphrase: "Choose a passphrase (this browser has no passkey key)",
	unlock: "Unlock",
	pending: "pending",
	pendingNote: "Pending keys can't read every value yet: re-seal from a device that can (hq secrets reseal, or here).",
	reseal: "Re-seal from this device",
	resealing: "Re-sealing\u2026",
	revoke: "Revoke {{name}}",
	confirmRevoke: "Revoke? Then re-seal and rotate what it saw.",
	noDeviceKey: "Set up this device (Secrets) to read values here.",
	reveal: "Show value",
	revealing: "Confirm with your passkey\u2026",
	valueLabel: "Value",
	copy: "Copy",
	hide: "Hide",
};

/** Adds the bundle once, after i18n.init (called when the page renders). */
export function registerSecretsStrings() {
	if (!i18n.exists("secrets.title")) i18n.addResourceBundle("en", "translation", { secrets: en }, true, false);
}
